export default __webpack_public_path__ + "assets/images/icon-incoming-call.2e554f252ddd216e27ff4f924517ff52.svg";